import axios from "axios";

const API_BASE_URL = `${process.env.REACT_APP_SERVICE_URL}`;

export const saveEducation = async (token: any, educationData: any) => {
  try {
    const response = await axios.post(
        `${API_BASE_URL}/SaveEducation`,
        educationData,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        }
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting Professional Experience:", error);
    throw error;
  }
};
